"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchNotifications } from "@/Redux/slice/notificationSlice";
export default function useNotificationRefresh(userId) {
  const $ = _c(7);
  const dispatch = useDispatch();
  const inFlight = useRef(null);
  let t0;
  if ($[0] !== dispatch || $[1] !== userId) {
    t0 = () => {
      if (!userId || document.visibilityState !== "visible") {
        return Promise.resolve(null);
      }
      if (inFlight.current) {
        return inFlight.current;
      }
      const request = dispatch(fetchNotifications({
        userId,
        refresh: true
      }));
      inFlight.current = request;
      request.finally(() => {
        if (inFlight.current === request) {
          inFlight.current = null;
        }
      });
      return request;
    };
    $[0] = dispatch;
    $[1] = userId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const refresh = t0;
  let t1;
  let t2;
  if ($[3] !== refresh || $[4] !== userId) {
    t1 = () => {
      if (!userId) {
        return;
      }
      refresh();
      window.addEventListener("focus", refresh);
      document.addEventListener("visibilitychange", refresh);
      return () => {
        window.removeEventListener("focus", refresh);
        document.removeEventListener("visibilitychange", refresh);
        inFlight.current?.abort();
        inFlight.current = null;
      };
    };
    t2 = [refresh, userId];
    $[3] = refresh;
    $[4] = userId;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  return refresh;
}